module.exports = __webpack_public_path__ + "img/43_5.65ee8e54.png";